import type { SubscriptionsSku } from '@calm-web/api-sdk/lib/atlas-subscriptions-api';

export default function getSubscriptionEventProps(sku: SubscriptionsSku) {
	return {
		'subscription.discount_percent': sku.discount ? Number(sku.discount.split('%')[0]) : 0,
		'subscription.product_price': sku.finalPrice / 1000,
		'subscription.currency_code': sku.currency,
		'subscription.sku': sku.rawSKU,
		'subscription.duration': sku.duration ?? null,
		'subscription.product': 'sleep',
		'subscription.payment_processor': 'stripe',
		'subscription.is_free_trial': Boolean(sku.trialDuration),
	};
}
